import {
  FETCHED_HISTORY,
  START_FETCHING_HISTORY
} from '../actionTypes';

import { HistoryDocumentType } from '../../types/AppTypes';

interface InitialState {
  historyDocument:HistoryDocumentType[];
  loading: boolean;
  error: any;
  message: any;
  tablePageSize: number;
  currentPage: number;
}

const initialState: InitialState = {
  historyDocument: [],
  loading: false,
  error: null,
  message: null,
  tablePageSize: 10,
  currentPage: 1,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_FETCHING_HISTORY:
      return {
        ...state,
        historyDocument: [],
        error: null,
        message: null,
        loading: true,
      };
    case FETCHED_HISTORY: {
      const { historyDocument, error, message } = action.payload;
      return {
        ...state,
        historyDocument,
        error,
        message,
        loading: false,
      };
    }
    default:
      return state;
  }
}
